import { history } from "helpers";
import { Toast } from "./toast";

export const axiosErrorHandler = (error, action, checkUnauthorized = true) => {
  const requestStatus = error?.request?.status;
  const responseStatus = error?.response?.status;
  const dataStatus = error?.response?.data?.status;

  if (dataStatus === 400 || responseStatus === 400 || requestStatus === 400) {
    if (localStorage.getItem("token")) {
      //Toast({ type: "error", message: error?.response?.data?.data?.message });
      Toast({
        type: "error",
        message:
          error?.response?.data?.data?.message ||
          error?.response?.data?.message ||
          error?.response?.data?.data || error?.response?.data,
      });
    }
  }

  if (dataStatus === 401 || responseStatus === 401 || requestStatus === 401) {
    localStorage.clear();
    history.push("/auth/login");
  }
  if (dataStatus === 422 || responseStatus === 422 || requestStatus === 422) {
    const message =
      error?.response?.data?.Error || error?.response?.data?.message;
    message && Toast({ type: "error", message });
  }

  if (
    checkUnauthorized &&
    (dataStatus === 409 || responseStatus === 409 || requestStatus === 409)
  ) {
    if (localStorage.getItem("token")) {
      history.push("/doctor/dashboard");
      Toast({ type: "error", message: "UnAuthorized URL" });
    } else history.push("/auth/login");
  }

  if (action === "uploadImage") {
    if (dataStatus === 500 || responseStatus === 500 || requestStatus === 500) {
      if (localStorage.getItem("token")) {
        const message = error?.response?.data?.message;
        message && Toast({ type: "error", message });
      } else history.push("/auth/login");
    }
  }

  if (error.response) return error.response;
  else if (error.request) return error.request;
  else return error.message;
};
